<template>
  <div>
    <documents-add-edit-modal
      v-if="showDocumentsModal"
      v-model="showDocumentsModal"
      :sidebarItems="sidebarItems"
      :selectedSidebarItemIndex="selectedSidebarItemIndex"
      sidebarTitle=""
      :modalTitle="modalTitle"
      :modalSubtitle="modalSubtitle"
      :reloadSelectedDocument="reloadSelectedDocument"
      @onModify="onModify"
      @setCurrentFormItem="setCurrentFormItem"
      :scheduleEventId="scheduleEventId"
      :scheduleEventParticipantId="scheduleEventParticipantId"
      :disableEffectiveDatePicker="disableEffectiveDatePicker"
      :attachForm="attachForm"
      :hasAppointmentRelated="hasAppointmentRelated"
    />
  </div>
</template>

<script>
import DocumentsAddEditModal from "../../document_archive/DocumentsAddEditModal";
import eocServer from "../../../server/eoc";
import { mapGetters, mapActions } from "vuex";
import scheduleEventServer from "../../../server/scheduleEvent";
import { formatDateOnly } from "../../../helpers/date";

export default {
  name: "DocumentAddEditModal",
  components: { DocumentsAddEditModal },
  props: [
    "formId",
    "clientId",
    "eocId",
    "submitId",
    "parentDocumentId",
    "otherResults",
    "defaultValues",
    "initialEffectiveDateTime",
    "scheduleEventId",
    "scheduleEventParticipantId",
    "documentRefNumber",
    "attachForm",
    "hasAppointmentRelated"
  ],
  data() {
    return {
      sidebarItems: null,
      selectedSidebarItemIndex: 0,
      showDocumentsModal: false,
      eoc: null,
      form: null,
      reloadSelectedDocument: +new Date(),
      disableEffectiveDatePicker: false,
      documentRefNumberValue: null
    };
  },
  async mounted() {
    this.fetchDiagnosisCodeStatuses();
    const sidebarItems = [];
    this.form = await this.getFormBuilderFormById(this.formId);
    this.eoc = await eocServer.get(this.eocId);
    if (this.submitId) {
      this.submit = await this.getFormSubmitById(this.submitId);
    }
    if (this.submit && this.submit.scheduleEventId) {
      const scheduleEvent = await scheduleEventServer.get(
        this.submit.scheduleEventId
      );
      if (scheduleEvent.type.name == "Group Session") {
        this.disableEffectiveDatePicker = true;
      }
    }
    sidebarItems.push({
      formId: this.formId,
      documentId: this.submitId,
      parentDocumentId: this.parentDocumentId,
      otherResults: this.otherResults,
      defaultValues: this.defaultValues,
      initialEffectiveDateTime: this.initialEffectiveDateTime,
      clientId: this.clientId,
      eocId: this.eocId,
      name: this.form.name,
      tooltip: this.form.name,
      documentStatus: this.submit ? this.submit.status : "",
      patientData: this.eoc.patient,
      date: this.form.createdAt
    });
    this.sidebarItems = sidebarItems;
    this.showDocumentsModal = true;
  },
  methods: {
    ...mapActions("client", ["fetchDiagnosisCodeStatuses"]),
    onModify(params) {
      this.$emit("onModify", params);
    },
    async setCurrentFormItem(params) {
      if (params.prevDocumentStatus == "Completed")
        this.onModify({
          refetchDocuments: true
        });

      if (params.documentRefNumber)
        this.documentRefNumberValue = params.documentRefNumber;

      this.sidebarItems[0].documentStatus = params.prevDocumentStatus;
      this.sidebarItems[0].documentId = params.prevDocumentId;
    }
  },
  computed: {
    ...mapGetters("formBuilder", ["getFormBuilderFormById"]),
    ...mapGetters("formSubmitter", ["getFormSubmitById"]),
    modalTitle() {
      if (this.form) {
        return `${
          this.documentRefNumberValue
            ? "Ref# " + this.documentRefNumberValue + " | "
            : ""
        }${this.form.name}`;
      }
      return "";
    },
    modalSubtitle() {
      let title = "";
      if (this.eoc) {
        const mrnDescription = this.eoc.patient.mrn ? "Mr# " : "";
        title =
          mrnDescription +
          this.formatEoc(
            " | " + this.eoc.patient.firstName,
            this.eoc.patient.middleName,
            this.eoc.patient.preferredName,
            this.eoc.patient.lastName,
            this.eoc.patient.mrn,
            this.eoc.eocn
          ) +
          ` | ${formatDateOnly(this.eoc.patient.dateOfBirth)}` +
          ` | ${this.eoc.patient.pronoun ? this.eoc.patient.pronoun.name : ""}`;
      }
      return title;
    }
  }
};
</script>

<style scoped>
div >>> .dropdown-menu {
  width: 100%;
}
</style>
